module.exports = __webpack_public_path__ + "officialStatic/img/new15.acc4d9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/new15.jpg
// module id = OX1t
// module chunks = 0